<ul *ngFor="let section of sections">
  <section-detail [section]="section"></section-detail>
</ul>

<!--<section-list-table [sections]="sections" (toggleSelectSection)="openSection($event)"></section-list-table>-->
